/**
 * Normalize the metadata every manual self-report sends, independent of the
 * platform-specific form controls that produced it.
 */
export function manualSignalEntryBase(input) {
    const occurredAt = new Date(input.occurredAt);
    if (Number.isNaN(occurredAt.valueOf()))
        return null;
    const note = cleanOptionalText(input.note);
    const quickAction = cleanOptionalText(input.quickAction);
    const surface = cleanOptionalText(input.surface);
    return {
        occurredAt: occurredAt.toISOString(),
        ...(note ? { note } : {}),
        ...(quickAction ? { quickAction } : {}),
        ...(surface ? { surface } : {}),
    };
}
function cleanOptionalText(value) {
    const trimmed = value?.trim();
    return trimmed ? trimmed : null;
}
//# sourceMappingURL=manual-signal-entry.js.map